import { Component, OnInit } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  layoutConfiguration: any;
  footerType: string;
  isSidebarEnabled: boolean;
  themes: any[] = [];

  constructor(
    private layoutService: LayoutService,
    private themeService: ThemeService
  ) { }

  ngOnInit(): void {
    this.layoutConfiguration = this.layoutService.layoutConfiguration;
    this.footerType = this.layoutConfiguration.footerOptions.footerType ? this.layoutConfiguration.footerOptions.footerType : '';
    this.isSidebarEnabled = this.layoutConfiguration.showSidebar;
    this.themes = this.themeService.themes;
  }

}
